<template lang="html">
  <section class="app-update-news-type">
    <p class="text-success" v-if="messageSubmission">
      <strong>{{ messageSubmission }}</strong>
    </p>
    <p v-if="!getCurrentElement">
      Please go first to the "<a href="#" @click="navigateAway('read')"><strong><em>Read</em></strong></a>"
      tab and select the award you would like to update.
    </p>
    <form v-else @submit.prevent="onSubmit" class=" text-left" :class="$v.dataForm.$invalid ? '':'was-validated'">
      <div class="form-group d-flex">
        <label for="newsType" class="w-25 align-self-center">* Type :</label>
        <div class="w-100">
          <input :class="$v.dataForm.newsType.$error ? 'is-invalid': ''" type="text"
                 @blur="$v.dataForm.newsType.$touch() || (dataForm.newsType = (dataForm.newsType === '') ? savedData.type : dataForm.newsType)"
                 v-model="dataForm.newsType"
                 class="form-control" id="newsType">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.newsType.required">
              You must absolutely enter a news type !
            </div>
            <div v-if="!$v.dataForm.newsType.minLength">
              News type must not have less than {{$v.dataForm.newsType.$params.minLength.min}} characters !</div><div v-if="!$v.dataForm.newsType.maxLength">
              News type must not contain more than {{$v.dataForm.newsType.$params.maxLength.max}} characters !
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 mb-4 text-center">
        <button :class="$v.dataForm.$invalid ? 'cursor-pointer-disabled':''"
                type="submit" class="btn btn-success" :disabled="$v.dataForm.$invalid">
          Submit
        </button>
        <button type="button" class="btn btn-danger ml-3" @click="resetForm">
          Reset
        </button>
      </div>
    </form>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
import {FORM_NEWS_TYPES_VALIDATIONS} from '../../validations/formNewsTypes'
export default {
  name: 'UpdateNewsType',
  props: [],
  mounted () {},
  created () {
    this.readOneData()
      .then(data => {
        this.savedData = data;
        this.dataForm.newsType = this.savedData.type;
      })
      .catch()
  },
  validations: FORM_NEWS_TYPES_VALIDATIONS,
  data () {
    return {
      savedData : null,
      dataForm : {
        newsType: undefined
      },
      messageSubmission: ""
    }
  },
  methods: {
    ...mapActions([
      'setOperation',
      'setCrudComponent',
      'readOneData',
      'updateData'
    ]),
    navigateAway(tab) {
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    },
    onSubmit () {
      const formData = {
        news_type_id : (this.getCurrentElement) ? this.getCurrentElement.id : '',
        type: this.dataForm.newsType
      };
      this.updateData(formData)
        .then(data => {
          this.messageSubmission = data;
          setTimeout( () => this.messageSubmission = '', 5000);
        })
        .catch()
    },
    resetForm () {
      this.dataForm.newsType = this.savedData.type;
    }
  },
  computed: {
    ...mapGetters([
      'getComponent',
      'getCurrentElement'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-update-news-type {}
</style>



// WEBPACK FOOTER //
// src/components/news_types/UpdateNewsType.vue